import { Box, Text } from '@betterment/samba-react';

export type TaxImpactUnavailableParams = {
  header: string;
  body: string;
};

export const TaxImpactUnavailable: React.FC<TaxImpactUnavailableParams> = ({ header, body }) => {
  return (
    <Box
      css={{
        display: 'flex',
        justifyContent: 'flex-start',
        flexDirection: 'column',
      }}
    >
      <Box>
        <Text>{header}</Text>
      </Box>
      <Box css={{ marginTop: 'space.300' }}>
        <Text css={{ color: 'primitives.grey.50' }}>{body}</Text>
      </Box>
    </Box>
  );
};
